module.exports = __webpack_public_path__ + "static/media/simplicity.8a6042bd.png";